<template>
  <div>
    <Loader></Loader>
    <div>
      <v-layout row wrap class="mt-10">
        <v-flex md3 sm12 class="ml-6">
          <v-card
            class="mx-4 mt-4"
            shaped
            elevation="12"
            max-width="344"
            outlined
            v-if="company != null"
          >
            <v-list-item three-line>
              <v-list-item-content>
                <div class="overline mb-4">Company Profile</div>

                <v-list-item-title class="headline mb-1">{{
                  company.name
                }}</v-list-item-title>
                <v-list-item-subtitle>{{ company.name }}</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar tile size="80" :color="getThemeColor">
                <input
                  type="file"
                  id="files"
                  ref="fileInput"
                  style="display: none"
                  accept="image/*"
                  @change="getSelectedImage()"
                />
                <v-img
                  size="80"
                  :src="companyLogo"
                  style="border-radius: 50%"
                  @click="openImageDialog()"
                ></v-img>
              </v-list-item-avatar>
            </v-list-item>

            <v-list two-line>
              <!-- <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-office</v-icon>
                </v-list-item-icon> -->

              <!-- <v-list-item-content>
                  <v-list-item-title>{{
                  company.registration
                  }}</v-list-item-title>
                  <v-list-item-subtitle>Registration</v-list-item-subtitle>
                </v-list-item-content> -->

              <!-- <v-list-item-icon>
                  <v-icon>mdi-message-text</v-icon>
                </v-list-item-icon>
              </v-list-item> -->

              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-bank</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{
                    company.primaryAddress
                  }}</v-list-item-title>
                  <v-list-item-subtitle>Address</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-phone</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{
                    company.primaryPhone
                  }}</v-list-item-title>
                  <v-list-item-subtitle>Phone</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-folder</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title
                    >City: {{ company.city }}</v-list-item-title
                  >
                  <v-list-item-subtitle
                    >Email: {{ company.email }}</v-list-item-subtitle
                  >
                  <v-list-item-subtitle
                    >Website: {{ company.doamin }}</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <v-card-actions>{{ company.description }}</v-card-actions>
          </v-card>
        </v-flex>
        <v-flex md8 sm12>
          <v-card class="mt-4" shaped>
            <v-tabs
              v-model="tab"
              :background-color="getThemeColor"
              :color="getSecondaryColor"
              centered
              icons-and-text
              dark
            >
              <v-tabs-slider></v-tabs-slider>
              <v-tab href="#tab-1" @click="getUserProfile()">
                Create Company
                <v-icon>mdi-account-box</v-icon>
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item value="tab-1">
                <v-layout row wrap>
                  <v-flex
                    md3
                    sm8
                    v-for="(dataArr, i) in companyData"
                    :key="i + Math.random() + Math.random()"
                    class="ml-8 mt-6"
                  >
                    <v-card shaped class="mt-4">
                      <v-card-text
                        :style="{ 'backgroung-color': getThemeColor }"
                        >{{
                          dataArr[0].toUpperCase().replace("_", " ")
                        }}</v-card-text
                      >
                      <div>
                        <v-text-field
                          class="mx-2"
                          @blur="updateField(dataArr[0], $event)"
                          :value="dataArr[1]"
                        >
                        </v-text-field>
                      </div>
                    </v-card>
                  </v-flex>
                  <v-flex md3 sm8 class="ml-8 mt-6">
                    <v-card shaped class="mt-4">
                      <v-btn
                        class="mx-7 my-7"
                        rounded
                        x-large
                        dark
                        :color="getThemeColor"
                        @click="createCompany()"
                      >
                        Create</v-btn
                      >
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-flex>
        <Loader></Loader>
        <div class="text-center"></div>
      </v-layout>
    </div>
  </div>
</template>

<script>
import Loader from "@/components/Loader.vue";
import axios from "@/plugins/axios";

export default {
  mounted() {
    this.getCompanyProfile();
  },
  components: { Loader },
  computed: {
    isManager() {
      return this.$store.getters.isManager;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isStaff() {
      return this.$store.getters.isStaff;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    isLegalPractice() {
      return this.$store.getters.isLegalPractice;
    },
  },

  data: () => ({
    companyLogo: null,
    companyData: [],
    tab: null,
    company: {
      name: "My Sample Company",
      description: "We are a general company",
      primaryPhone: "012 345 6789",
      primaryAddress: "123 Durban Street",
      city: "Durban",
      email: "abc@gmail.com",
    },
  }),
  methods: {
    getCompanyProfile() {
      if (this.company != null) {
        this.companyData = [];
        const companyData = Object.entries(this.company);
        companyData.forEach((dataArr) => {
          this.companyData.push(dataArr);
        });
      }
      this.$store.commit("setLoader", false);
    },
    updateField(column, $event) {
      this.company[column] = $event.target.value;
      this.getCompanyProfile();
    },
    createCompany() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/create-company",
          this.company,
          this.getAccessToken
        )
        .then((response) => {
          this.$store.commit("setLoader", false);
          if (response == "success") {
            this.$router.push({ name: "switchboard" });
          }
        });
    },
  },
};
</script>

<style></style>
